import { TimelineContent, TimelineItem, TimelineSeparator } from "@mui/lab";
import { Box, ListItemText, styled } from "@mui/material";
import { tokens } from "@/tokens";

export const StyledTimelineSeparator = styled(TimelineSeparator)(() => ({
  marginRight: "8px",
  "& .MuiTimelineConnector-root": {
    backgroundColor: "#E6E6E6",
    borderRadius: "15px",
  },
  "& .MuiTimelineDot-root.MuiTimelineDot-filled": {
    margin: "4px 0",
    backgroundColor: "#E6E6E6",
    height: "30px",
    width: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const StyledHeader = styled(Box)(() => ({
  borderBottom: `1px solid ${tokens.border.default}`,
  padding: "26px",
  color: tokens.brand.primary,
}));

export const StyledSkeletonBox = styled(Box)(() => ({
  padding: "0 17px 0px 17px",
}));

export const StyledTimelineContent = styled(TimelineContent)(() => ({
  padding: "0px",
  paddingTop: 0,
}));

export const StyledTimelineItem = styled(TimelineItem)(() => ({
  minHeight: "55px",
}));

export const StyledListItemText = styled(ListItemText)(() => ({
  display: "flex",
  alignItems: "center",
  fontSize: tokens.fontSize.lg,
  fontWeight: tokens.fontWeight.semibold,
  lineHeight: 1.57,
  color: "#7F7D83",
}));
